import type { Meta } from '@brighterly/lib-core-types/api/interfaces'
import type { CustomersStore } from './interfaces'

import { isFullArray } from '@shared/lib/collections'

export const getters = {
  isLoading: (state: CustomersStore): CustomersStore['loading'] => state.loading,
  getCustomers: (state: CustomersStore): CustomersStore['customers'] => state.customers,
  hasCustomers: (state: CustomersStore): boolean => isFullArray(state.customers),
  getMeta: (state: CustomersStore): Meta | null => state.meta,
  hasNextPage: (state: CustomersStore): boolean => !!state.meta?.next_page_url,
  hasPrevPage: (state: CustomersStore): boolean => !!state.meta?.prev_page_url,
  getFilterSearch: (state: CustomersStore): CustomersStore['filterSearch'] => state.filterSearch,
  getFilterStatus: (state: CustomersStore): CustomersStore['filterStatus'] => state.filterStatus,
  getFilterStages: (state: CustomersStore): CustomersStore['filterStages'] => state.filterStages,
  getFilterFrom: (state: CustomersStore): CustomersStore['filterFrom'] => state.filterFrom,
  getFilterTo: (state: CustomersStore): CustomersStore['filterTo'] => state.filterTo,
  getFilterSourceFunnel: (state: CustomersStore): CustomersStore['filterSourceFunnel'] => state.filterSourceFunnel,
  getFilterTutorId: (state: CustomersStore): CustomersStore['filterTutorId'] => state.filterTutorId,
  getFilterStudyingStatus: (state: CustomersStore): CustomersStore['filterStudyingStatus'] => state.filterStudyingStatus,
  getCurrentPage: (state: CustomersStore): CustomersStore['currentPage'] => state.currentPage,
  getPerPage: (state: CustomersStore): CustomersStore['perPage'] => state.perPage,
  getDeleteCustomerId: (state: CustomersStore): CustomersStore['deleteCustomerId'] => state.deleteCustomerId,
  isDeleting: (state: CustomersStore): CustomersStore['deleting'] => state.deleting,
}
